<template>
  <v-data-table
    class="ma-10"
    :no-data-text="$t('messages.information.no_data')"
    :dense="dense"
    :headers="headers"
    :items="items"
    :items-per-page="-1"
    :search="search"
    item-key="id"
    @click:row="($event, { item }) => handleClickEvent(item)"
  >
    <template v-slot:top>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          v-model="search"
          :label="$t('commons.search')"
        ></v-text-field>
      </v-toolbar>
    </template>

    <template v-slot:item.icon="{ item }">
      <v-icon color="primary">{{ item.icon }}</v-icon>
    </template>

    <template v-slot:item.company="{ item }">
      <span class="text-uppercase">{{ item.company }}</span>
    </template>

    <template v-slot:item.project="{ item }">
      <span class="text-uppercase">{{ item.project }}</span>
    </template>

    <template v-slot:item.object="{ item }">
      <avs-chip styleC="width: 150px"> {{ item.object }} </avs-chip>
    </template>

    <template v-slot:item.datetime="{ item }">
      {{ toDatetime(item.datetime) }}
    </template>

    <template v-slot:item.info="{ item }">
      <span class="text-uppercase">{{ item.info }}</span>
    </template>

    <template v-slot:item.read="{ item }">
      <v-icon
        color="primary"
        v-if="item.read === false"
        >mdi-bell
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { toDatetime } from "@/utils/datetime"
// shortcut to build headers
const sf = (sortable, filterable) => ({ sortable, filterable })

export default {
  name: "NotificationDatatable",
  props: {
    dense: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: "", value: "icon", ...sf(false, false) },
        { text: "Company", value: "company", align: "center", ...sf(true, false) },
        { text: "Project", value: "project", class: "min-width-200", ...sf(true, false) },
        { text: "Object", value: "object", align: "center", ...sf(true, false) },
        { text: "Name", value: "name", class: "min-width-200", ...sf(true, true) },
        { text: "Date Time", value: "datetime", ...sf(true, false) },
        { text: "Info", value: "info", align: "center", ...sf(true, true) },
        { text: "Read", value: "read", width: 90, ...sf(true, true) }
      ],
      search: ""
    }
  },
  methods: {
    toDatetime,
    handleClickEvent(item) {
      this.$emit("click", item)
    }
  }
}
</script>
